module.exports = __webpack_public_path__ + "static/media/wbtc.45e73281.svg";